export class AtualizaNovaSenhaSignature {
  novoPassword: string = null;
        
    constructor(values: Partial<AtualizaNovaSenhaSignature> = { }) {
  
    Object.assign(this, values)
    }
  }
  